import { LogItemProps } from '../LogItemLayout';

const getStoreName = (data: any) => {
  return data?.map((v: any) => v?.storeName || v?.alias).join(', ');
};

export const useStore = (data: LogItemProps['data']) => {
  const { operateType, changeField, changeDetail } = data;

  if (operateType !== 'UPDATE_TASK' && operateType !== 'UPDATE_POLICY') return null;

  if (changeField === 'TASK_STORE' || changeField === 'POLICY_STORE') {
    return {
      // @ts-ignore
      addStore: getStoreName(changeDetail?.after?.addStore),
      // @ts-ignore
      removeStore: getStoreName(changeDetail?.after?.removeStore),
    };
  }
};
